<template>
  <component
    :is="elementBindings.is"
    v-bind="elementBindings"
    class="button-base"
    :class="{ 'button-base--button': isButton }"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'ButtonBase',

  computed: {
    isButton() {
      return this.elementBindings.is === 'button';
    },

    elementBindings() {
      let elementBindings = { is: 'button', type: 'button' };

      if ('to' in this.$attrs) {
        elementBindings = { is: 'router-link' };
      } else if ('href' in this.$attrs) {
        elementBindings = { is: 'a', rel: 'noopener' };
      }

      return {
        ...elementBindings,
        ...this.$attrs,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
// we use a class here instead of button.button-base to make it easy to overwrite
.button-base--button {
  @include helper__button;
  user-select: none;
}
</style>
